import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { Flex, Layout as AntdLayout, Skeleton } from 'antd';
import AddFeedCardModal from '../components/AddFeedCardModal';
import GiideSideMenuLeft from '../components/GiideSideMenuLeft';
import GiideSideMenuRight from '../components/GiideSideMenuRight';
import GiideWithStep from '../components/GiideWithStep';
import NewStep from '../components/NewStep';

import useGiide from '../hooks/useQuery/useGiide';
import useUser from '../hooks/useUser';
import { setOpenedStep } from '../actions';
import { IState } from '../graphql/types';
import { giideTabState } from '../types';
import { haveGiideChapters } from '../components/utils';
import { colors } from '../theme';

const GiidePage: React.FC<RouteComponentProps> = ({
  history: { push },
  match: { params },
}) => {
  const id = (params as { id?: string })?.id ?? '';
  if (!id) {
    push('/');
  }
  const dispatch = useDispatch();
  const { openedStep, data, steps, refetch } = useGiide(id);
  const { user } = useUser();

  const hasChapters = haveGiideChapters(data, user);
  const tabState = useSelector<IState, giideTabState>(state => state.tabState);

  useEffect(() => {
    /*if (openedStep?.order === 1000) {
      dispatch(setOpenedStep(steps?.[0]?.order));
    } else if (openedStep?.order === 2000) {
      dispatch(setOpenedStep((stpkeps?.length ?? 1) - 1));
    } else */ if (openedStep) {
      dispatch(setOpenedStep(openedStep.order));
    } else {
      dispatch(setOpenedStep(steps?.[0]?.order));
    }
  }, [openedStep, dispatch, steps]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  let loading =
    data === undefined ||
    (typeof data.giideLibraryId === 'string' &&
      !data.giideLibraryAlreadyMerged);

  if (!user) {
    return null;
  }

  return (
    <>
      <NewStep />
      <AddFeedCardModal />
      {loading && (
        <AntdLayout.Sider
          style={{ borderRight: '1px solid ' + colors.white3 }}
          theme={'light'}
          width="167pt"
        >
          <Flex
            vertical={true}
            gap={'small'}
            justify={'center'}
            align={'center'}
            style={{ margin: '12px 0 auto' }}
          >
            <Skeleton.Input size={'large'} active></Skeleton.Input>
            <Skeleton.Input size={'large'} active></Skeleton.Input>
            <Skeleton.Input size={'large'} active></Skeleton.Input>
            <Skeleton.Input size={'large'} active></Skeleton.Input>
          </Flex>
        </AntdLayout.Sider>
      )}

      {hasChapters && !loading && tabState !== 'published' && (
        <AntdLayout.Sider
          style={{ borderRight: '1px solid ' + colors.white3 }}
          theme={'light'}
          width="220px"
        >
          <GiideSideMenuLeft />
        </AntdLayout.Sider>
      )}

      <AntdLayout.Content
        className={`main-content-giide ${
          tabState === 'published' ? 'main-content-published' : ''
        }`}
      >
        {loading && (
          <Flex
            justify={'space-between'}
            style={{ width: '460px', margin: '32px auto 24px' }}
          >
            <Skeleton.Avatar size={'small'}></Skeleton.Avatar>
            <Skeleton.Avatar size={'small'}></Skeleton.Avatar>
            <Skeleton.Avatar size={'small'}></Skeleton.Avatar>
          </Flex>
        )}

        <Skeleton active paragraph={{ rows: 8 }} loading={loading}>
          {openedStep && <GiideWithStep hasChapters={hasChapters} />}
        </Skeleton>
      </AntdLayout.Content>

      {tabState !== 'published' && (
        <GiideSideMenuRight hasChapters={hasChapters} loading={loading} />
      )}
    </>
  );
};

export default GiidePage;
